// extracted by mini-css-extract-plugin
module.exports = {"foreGround":"_3_g6A","hidden":"_2E80K"};